import * as yup from 'yup'

export const markAsLostValidation: yup.SchemaOf<any> = yup
  .object({
    reasonId: yup.string().nullable().required().label('Reason'),
  })
  .required()
